import { Menu, Transition } from '@headlessui/react';
import cx from 'classnames';
import { Fragment } from 'react';

import { useWebThemeContext } from '../Layout/Context/useWebThemeContext';

interface Props {
  children: React.ReactNode;
  buttonChild?: React.ReactNode;
  direction?: 'left' | 'right' | 'center';
  className?: string;
  style?: React.CSSProperties;
}

const LEFT_DIRECTION = 'origin-top-right left-0';
const RIGHT_DIRECTION = 'origin-top-right right-0';
const CENTER_DIRECTION = 'origin-top-center right-0';

const DIRECTION_MAP = Object.freeze({
  right: RIGHT_DIRECTION,
  left: LEFT_DIRECTION,
  center: CENTER_DIRECTION,
});

const Dropdown = ({ children, buttonChild, direction = 'right', className, style = {} }: Props) => {
  const { classes } = useWebThemeContext();

  return (
    <>
      <Menu as="div" className="relative inline-block text-left">
        <Menu.Button aria-label="Menu" className="rounded-full transition-all">
          {buttonChild}
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className={cx(
              classes.radius,
              'absolute mt-2 bg-white bg-wt-tertiary shadow-lg ring-1 ring-black/5 focus:outline-none',
              DIRECTION_MAP[direction],
              className,
            )}
            style={style}
          >
            {children}
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  );
};

export default Dropdown;
